<!--年框列表——有效的客户/集团-->
<template>
  <div class="year-frame-ack-list-container" v-loading="loading" >
    <div class="year-frame-ack-list-container__content" >
      <div class="tab">
        <span :class="{active:type==='customer'}" @click="type='customer'">客户</span>
        <span :class="{active:type==='combine'}" @click="type='combine'">集团</span>
        <span :class="{active:type==='profileCustomer'}" @click="type='profileCustomer'">重点客户</span>
      </div>
      <template v-if="type === 'customer'||type === 'combine'">
        <div style="margin-top: 20px;margin-bottom:40px;text-align: center;">
          <el-input placeholder="可输入关键词查找" v-model="value" style="width: 500px;" @keydown.enter.native="search">
            <el-button slot="append" icon="el-icon-search" class="search-btn" @click="search"/>
          </el-input>
        </div>
        <div class="grid">
          <div v-for="({name},index) in table" class="grid-item" :key="`col-${name}`">
            {{ (page - 1) * page_size + index + 1 }}.&nbsp;{{ name }}
          </div>
        </div>
        <el-pagination
            background
            :current-page="page"
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total"
            style="margin-top: 10px;float: right;"
            @current-change="handleCurrentChange"
        />
      </template>
      <template v-if="type==='profileCustomer'">
        <profile-customer v-if="userAuth.key_customer"></profile-customer>
        <div class="d-flex-column d-flex-center" style="text-align: center;height: 100%;width: 100%;color: #ab1010;" v-else>
          <span style="font-size: 20px">暂无权限</span>
        </div>
      </template>

    </div>

  </div>

</template>

<script>
import {yearFrameAckList} from "@/api/customerYearFrame";
import profileCustomer from '@/views/custom/components/customer/index.vue'

export default {
  name: "YearFrameAckList",
  components: {profileCustomer},
  computed:{
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  data() {
    return {
      loading: false,
      type: 'customer',
      value: null,
      page_size: 40,
      page: 1,
      total: 0,
      table: []
    }
  },
  watch: {
    type() {
      this.search()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init: function () {
      this.getData()
    },
    search: function () {
      this.page = 1
      this.getData()
    },
    getData: async function () {
      this.loading = true
      const {model: {data, total}} = await yearFrameAckList({
        model: this.type,
        name: this.value,
        page: this.page,
        page_size: this.page_size
      })
      this.loading = false
      this.table = data || []
      this.total = total || 0
    },
    handleCurrentChange: function (val) {
      this.page = val
      this.getData()
    },
  }
}
</script>
<style lang="scss">
.year-frame-ack-list-container {
  font-family: FjallaOne-Regular, sans-serif !important;
  padding: 24px;
  background: #f3f3f3;
  height: calc(100% - 48px);

  p {
    margin-block-start: 0;
    margin-block-end: 0;
  }

  &__content {
    background: #FFFFFF;
    height: calc(100% - 60px);
    border-radius: 6px;
    padding: 30px;
    position: relative;

    .title {
      font-size: 15px;
      font-weight: 500;
      margin-bottom: 8px;
    }

    .tab {
      text-align: center;

      span {
        color: #45474d;
        font-weight: 700;
        padding: 6px 18px;
        border-radius: 20px;
        cursor: pointer;
        font-size: 14px;
      }

      span.active {
        background-color: #fe346e;
        font-weight: 400;
        color: #fff;
      }
    }

    .search-btn {
      background-color: #fe346e !important;
      border-color: #fe346e !important;
      color: #fff !important;
    }
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    //grid-template-rows: repeat(15, 1fr);
    gap: 10px;

    .grid-item {
      background-color: rgba(255, 255, 255, 0.8);
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      padding: 8px;
    }
  }

  .el-pagination {
    position: absolute;
    bottom: 24px;
    right: 24px;
  }
}
</style>
